// extracted by mini-css-extract-plugin
module.exports = {"certification":"Certification_certification__3jpa5","left":"Certification_left__NGbbw","right":"Certification_right__1QxsN","text":"Certification_text__34Ay6"};